import {Component, OnInit} from "@angular/core";
import {DesignSystemModule} from "../../../design-system/design-system.module";
import {NgOptimizedImage} from "@angular/common";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {CopyTextModule} from "../../../global/input/copy-text/copy-text.module";
import {FormControl} from "@angular/forms";
import {TenantExtensionSettingsWithCredentials, TenantService} from "../../../../services/tenant.service";
import {CurrentTenantService} from "../../../../services/front/current-tenant.service";
import {mergeMap} from "rxjs";
import {tap} from "rxjs/operators";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-agent-download',
  templateUrl: './agent-download.component.html',
  imports: [
    DesignSystemModule,
    NgOptimizedImage,
    TranslateModule,
    CopyTextModule
  ],
  styleUrls: ['./agent-download.component.scss']
})
export class AgentDownload implements OnInit {
  protected operatingSystemForm = new FormControl('windows');
  protected architectureForm = new FormControl('x86_64');
  protected optionsForm = new FormControl('ext');
  protected architectureOptions = ['x86_64'];
  protected optionsOptions = ['ext', 'noExt'];
  protected tenantExtensionSettings:TenantExtensionSettingsWithCredentials;

  constructor(
    protected dialogRef: MatDialogRef<any>,
    protected currentTenantService: CurrentTenantService,
    protected translateService: TranslateService,
    protected tenantService: TenantService
  ) {}

  ngOnInit() {
    this.operatingSystemForm.valueChanges.subscribe((value) => {
        this.buildFormOptions(value || 'windows');
    });

    this.currentTenantService.getCurrentTenantId().pipe(
      mergeMap(tenantId => this.tenantService.getTenantExtensionSettingsWithCredentials(tenantId)),
      tap(settings => this.tenantExtensionSettings = settings)
    ).subscribe();
  }

  download() {
    if (this.operatingSystemForm.valid && this.architectureForm.valid && this.optionsForm.valid) {
      // Download agent
      if (this.operatingSystemForm.value === 'windows') {
        // Download Windows agent
        if (this.optionsForm.value === 'noExt') {
          window.open('https://app.kabeen.io/download/kabeen-no-ext-windows-x86.msi.html', '_blank');
        } else {
          window.open('https://app.kabeen.io/download/kabeen-windows-x86.msi.html', '_blank');
        }
      } else if (this.operatingSystemForm.value === 'macos') {
        if (this.architectureForm.value === 'x86_64') {
          window.open('https://app.kabeen.io/download/kabeen-macos-x86_64.pkg.html', '_blank');
        } else {
          window.open('https://app.kabeen.io/download/kabeen-macos-aarch64.pkg.html', '_blank');
        }
      }
    }
  }

  protected buildDefaultValues(operatingSystem: string) {
    this.architectureForm.setValue('x86_64');
    this.optionsForm.setValue('ext');
  }

  protected buildFormOptions(operatingSystem: string) {
    this.buildDefaultValues(operatingSystem);

    if (operatingSystem === 'windows') {
      this.architectureOptions = ['x86_64'];
      this.optionsOptions = ['ext', 'noExt'];
    } else {
      this.architectureOptions = ['x86_64', 'ARM64'];
      this.optionsOptions = ['ext'];
    }
  }

  protected getPrettyOSName(os: string | null): string {
    switch (os) {
      case 'windows':
        return 'Windows';
      case 'macos':
        return 'MacOS';
      case 'linux':
        return 'Linux';
      default:
        return 'Unknown';
    }
  }

  protected getPrettyArchitectureName(architecture: string | null): string {
    switch (architecture) {
      case 'x86_64':
        return 'x86_64 (Intel 64-bit)';
      case 'ARM64':
        return 'ARM64 (ARM 64-bit)';
      default:
        return 'Unknown';
    }
  }

  protected getPrettyOptionsName(options: string | null): string {
    switch (options) {
      case 'ext':
        return this.translateService.instant('page.agent.workstations.downloadPopUp.option1');
      case 'noExt':
        return this.translateService.instant('page.agent.workstations.downloadPopUp.option2');
      default:
        return 'Unknown';
    }
  }

  onClose() {
    this.dialogRef.close();
  }
}
